import React from 'react';
import { bool, object } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { resolveLatestProcessName, getProcess } from '../../transactions/transaction';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemReplacementFee = props => {
  const { replacementFee, intl } = props;

  const replacementFeeLabel = <FormattedMessage id="OrderBreakdown.replacementFee" />;

  if (!replacementFee) {
    return <></>;
  }

  const formattedTotalPrice = formatMoney(
    intl,
    new Money(Number(replacementFee.amount) * 100, replacementFee.currency)
  );

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>{replacementFeeLabel}</div>
        <div className={css.totalPrice}>{formattedTotalPrice}</div>
      </div>
    </>
  );
};

LineItemReplacementFee.propTypes = {
  replacementFee: object,
  intl: intlShape.isRequired,
};

export default LineItemReplacementFee;
